import React from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { i18n } from '../../translate/i18n';
import useDialogStyles from '../TransferTicketModalCustom/dialogStyles';

const ShowTicketOpen = ({ isOpen, handleClose, user, queue }) => {
  const classes = useDialogStyles({ width: 400 });

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      classes={{ paper: classes.paper }}
      aria-labelledby="ticket-open-title"
    >
      <div className={classes.header}>
        <h2 id="ticket-open-title" className={classes.title}>
          {i18n.t("showTicketOpenModal.title.header")}
        </h2>
        {user !== undefined && queue !== undefined && (
          <p className={classes.subtitle}>
            {i18n.t("showTicketOpenModal.form.message")}
          </p>
        )}
        {!user && (
          <p className={classes.subtitle}>
            {i18n.t("showTicketOpenModal.form.messageWait")}
          </p>
        )}
      </div>
      <DialogContent className={classes.content}>
        {user !== undefined && queue !== undefined && (
          <div className={classes.infoBox}>
            <div>{`${i18n.t("showTicketOpenModal.form.user")}: ${user}`}</div>
            <div>{`${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}</div>
          </div>
        )}
        {!user && queue && (
          <div className={classes.infoBox}>
            {`${i18n.t("showTicketOpenModal.form.queue")}: ${queue}`}
          </div>
        )}
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="contained"
          className={classes.confirm}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShowTicketOpen;
